import { Outlet } from 'react-router-dom';

const HowToManage = () => <Outlet />;

export default HowToManage;
